var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import CardProfile from '../../../../components/Card/Profile';
import { Languages } from '../../../../components/CustomIcon';
import Drawer from '../../../../components/Drawer';
import Heading from '../../../../components/Typography/Heading';
import Paragraph from '../../../../components/Typography/Paragraph';
import Button from '../../../../components/Button';
import { Plus, Trash } from 'react-feather';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../../../components/Fields/TextInput';
import { useUser } from '../../../../hooks/useUser';
import { deepEqual, pick } from '../../../../utils/Objects';
import { serialize } from 'object-to-formdata';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';
var DashboardPublicLanguages = function () {
    var _a = useOutletContext(), user = _a.user, handleUser = _a.handleUser, handleFormError = _a.handleFormError;
    var isDone = useUser().isDone;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), drawer = _c[0], setDrawer = _c[1];
    var max = 10;
    var languages = useValidation().languages;
    var schema = yup.object().shape({
        languages: languages(max),
    });
    var _d = useForm({
        resolver: yupResolver(schema),
    }), handleSubmit = _d.handleSubmit, control = _d.control;
    var _e = useFieldArray({ name: 'languages', control: control }), fields = _e.fields, append = _e.append, remove = _e.remove, replace = _e.replace;
    var handleDrawerClose = function () {
        var _a;
        setDrawer(false);
        if ((_a = user.languages) === null || _a === void 0 ? void 0 : _a.length)
            replace(user.languages);
    };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, 'languages')))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(data, { indices: true, allowEmptyArrays: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    toast.success('Vos langues ont bien été mises à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setDrawer(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!user.languages || !user.languages.length) {
            append({ language: '' });
        }
        else {
            append(user.languages);
        }
    }, []);
    return (<>
      <CardProfile title="Mes langues" description="Renseignez les langues étrangères parlées dans un contexte professionnel." filled={isDone('languages')} icon={Languages} onClick={function () {
            setDrawer(true);
        }}/>

      <Drawer handleClose={handleDrawerClose} open={drawer}>
        <div className="px-drawer pb-10">
          <div className="flex items-center justify-between">
            <Heading level={2} type="h5" className="mb-2">
              Mes langues
            </Heading>
            <Paragraph className="text-gray-400">{"".concat(fields === null || fields === void 0 ? void 0 : fields.length, "/").concat(max)}</Paragraph>
          </div>
          <Paragraph size="sm" className="mt-2 text-gray-700">
            Renseignez les langues étrangères parlées dans un contexte professionnel.
          </Paragraph>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-8 flex flex-col gap-3">
              {fields.map(function (field, i) {
            return (<div className="flex items-center gap-4" key={field.id}>
                    <TextInput label="Langue" control={control} placeholder="Ex : Allemand" name={"languages.".concat(i, ".language")} required/>
                    <Trash size={24} className="mt-6 flex-none cursor-pointer text-gray-400 transition-colors hover:text-brand-01" onClick={function () { return remove(i); }}/>
                  </div>);
        })}

              {fields.length < max && (<Button type="inline" icon={Plus} side="start" className="self-start text-brand-02" onClick={function () { return append({ language: '' }); }}>
                  Ajouter une langue
                </Button>)}

              <Button submit className="mt-10" loading={loading}>
                Sauvegarder
              </Button>
            </div>
          </form>
        </div>
      </Drawer>
    </>);
};
export default DashboardPublicLanguages;
